import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2AdminAppointmentsMaterialize: build.mutation<
      PostV2AdminAppointmentsMaterializeApiResponse,
      PostV2AdminAppointmentsMaterializeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/appointments/materialize`,
        method: "POST",
        body: queryArg.materializationRequest,
      }),
    }),
    getV2AdminAppointmentsMaterializeByTaskId: build.query<
      GetV2AdminAppointmentsMaterializeByTaskIdApiResponse,
      GetV2AdminAppointmentsMaterializeByTaskIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/appointments/materialize/${queryArg.taskId}`,
      }),
    }),
    getV2AdminAppointmentsByAppointmentId: build.query<
      GetV2AdminAppointmentsByAppointmentIdApiResponse,
      GetV2AdminAppointmentsByAppointmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/appointments/${queryArg.appointmentId}`,
      }),
    }),
    getV2AdminProvidersByProviderIdAppointments: build.query<
      GetV2AdminProvidersByProviderIdAppointmentsApiResponse,
      GetV2AdminProvidersByProviderIdAppointmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/appointments`,
      }),
    }),
    getV2ProviderAppointments: build.query<
      GetV2ProviderAppointmentsApiResponse,
      GetV2ProviderAppointmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments`,
        params: {
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          patient_id: queryArg.patientId,
          patient_ids: queryArg.patientIds,
          provider_ids: queryArg.providerIds,
          all_providers: queryArg.allProviders,
          sort: queryArg.sort,
        },
      }),
    }),
    postV2ProviderAppointments: build.mutation<
      PostV2ProviderAppointmentsApiResponse,
      PostV2ProviderAppointmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments`,
        method: "POST",
        body: queryArg.appointmentCreate,
      }),
    }),
    getV2ProviderAppointmentsNext: build.query<
      GetV2ProviderAppointmentsNextApiResponse,
      GetV2ProviderAppointmentsNextApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments/next`,
        params: {
          patient_id: queryArg.patientId,
          num: queryArg.num,
          include_recent_minutes: queryArg.includeRecentMinutes,
          context_mode: queryArg.contextMode,
          include_current: queryArg.includeCurrent,
          max_lookback_minutes: queryArg.maxLookbackMinutes,
        },
      }),
    }),
    postV2ProviderAppointmentsSeries: build.mutation<
      PostV2ProviderAppointmentsSeriesApiResponse,
      PostV2ProviderAppointmentsSeriesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments/series`,
        method: "POST",
        body: queryArg.appointmentSeriesCreate,
      }),
    }),
    deleteV2ProviderAppointmentsSeriesBySeriesId: build.mutation<
      DeleteV2ProviderAppointmentsSeriesBySeriesIdApiResponse,
      DeleteV2ProviderAppointmentsSeriesBySeriesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments/series/${queryArg.seriesId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderAppointmentsSeriesBySeriesId: build.query<
      GetV2ProviderAppointmentsSeriesBySeriesIdApiResponse,
      GetV2ProviderAppointmentsSeriesBySeriesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments/series/${queryArg.seriesId}`,
      }),
    }),
    patchV2ProviderAppointmentsSeriesBySeriesId: build.mutation<
      PatchV2ProviderAppointmentsSeriesBySeriesIdApiResponse,
      PatchV2ProviderAppointmentsSeriesBySeriesIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments/series/${queryArg.seriesId}`,
        method: "PATCH",
        body: queryArg.appointmentSeriesUpdate,
      }),
    }),
    deleteV2ProviderAppointmentsSeriesBySeriesIdFromAppointmentAndAppointmentId:
      build.mutation<
        DeleteV2ProviderAppointmentsSeriesBySeriesIdFromAppointmentAndAppointmentIdApiResponse,
        DeleteV2ProviderAppointmentsSeriesBySeriesIdFromAppointmentAndAppointmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/appointments/series/${queryArg.seriesId}/from-appointment/${queryArg.appointmentId}`,
          method: "DELETE",
        }),
      }),
    deleteV2ProviderAppointmentsByAppointmentId: build.mutation<
      DeleteV2ProviderAppointmentsByAppointmentIdApiResponse,
      DeleteV2ProviderAppointmentsByAppointmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments/${queryArg.appointmentId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderAppointmentsByAppointmentId: build.query<
      GetV2ProviderAppointmentsByAppointmentIdApiResponse,
      GetV2ProviderAppointmentsByAppointmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments/${queryArg.appointmentId}`,
      }),
    }),
    patchV2ProviderAppointmentsByAppointmentId: build.mutation<
      PatchV2ProviderAppointmentsByAppointmentIdApiResponse,
      PatchV2ProviderAppointmentsByAppointmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments/${queryArg.appointmentId}`,
        method: "PATCH",
        body: queryArg.appointmentUpdate,
      }),
    }),
    postV2ProviderAppointmentsByAppointmentIdNoShow: build.mutation<
      PostV2ProviderAppointmentsByAppointmentIdNoShowApiResponse,
      PostV2ProviderAppointmentsByAppointmentIdNoShowApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments/${queryArg.appointmentId}/no-show`,
        method: "POST",
      }),
    }),
    patchV2ProviderAppointmentsByAppointmentIdReject: build.mutation<
      PatchV2ProviderAppointmentsByAppointmentIdRejectApiResponse,
      PatchV2ProviderAppointmentsByAppointmentIdRejectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/appointments/${queryArg.appointmentId}/reject`,
        method: "PATCH",
        body: queryArg.appointmentReject,
      }),
    }),
    postV2ProviderEncountersFromAppointmentByAppointmentId: build.mutation<
      PostV2ProviderEncountersFromAppointmentByAppointmentIdApiResponse,
      PostV2ProviderEncountersFromAppointmentByAppointmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/from-appointment/${queryArg.appointmentId}`,
        method: "POST",
        params: {
          apply_defaults: queryArg.applyDefaults,
        },
      }),
    }),
    getV2ProviderEncountersByEncounterId: build.query<
      GetV2ProviderEncountersByEncounterIdApiResponse,
      GetV2ProviderEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}`,
      }),
    }),
    patchV2ProviderEncountersByEncounterId: build.mutation<
      PatchV2ProviderEncountersByEncounterIdApiResponse,
      PatchV2ProviderEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}`,
        method: "PATCH",
        body: queryArg.encounterUpdate,
        params: {
          include_defaults: queryArg.includeDefaults,
        },
      }),
    }),
    postV2ProviderPatientsClinicalInfo: build.mutation<
      PostV2ProviderPatientsClinicalInfoApiResponse,
      PostV2ProviderPatientsClinicalInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/clinical-info`,
        method: "POST",
        body: queryArg.patientClinicalInfoRequest,
      }),
    }),
    getV2ProviderPatientsByPatientIdClinicalInfo: build.query<
      GetV2ProviderPatientsByPatientIdClinicalInfoApiResponse,
      GetV2ProviderPatientsByPatientIdClinicalInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/clinical-info`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2AdminAppointmentsMaterializeApiResponse =
  /** status 200 OK */
    | MaterializationResultResponse
    | /** status 202 Accepted */ MaterializationTaskResponse;
export type PostV2AdminAppointmentsMaterializeApiArg = {
  materializationRequest: MaterializationRequest;
};
export type GetV2AdminAppointmentsMaterializeByTaskIdApiResponse =
  /** status 200 OK */ TaskStatusResponse;
export type GetV2AdminAppointmentsMaterializeByTaskIdApiArg = {
  taskId: string;
};
export type GetV2AdminAppointmentsByAppointmentIdApiResponse =
  /** status 200 OK */ AdminAppointmentDetailResponse;
export type GetV2AdminAppointmentsByAppointmentIdApiArg = {
  appointmentId: string;
};
export type GetV2AdminProvidersByProviderIdAppointmentsApiResponse =
  /** status 200 OK */ ListResponseAdminAppointmentResponse;
export type GetV2AdminProvidersByProviderIdAppointmentsApiArg = {
  providerId: string;
};
export type GetV2ProviderAppointmentsApiResponse =
  /** status 200 OK */ AppointmentListResponse;
export type GetV2ProviderAppointmentsApiArg = {
  /** Start date for filtering appointments (ISO format, required) */
  startDate: string;
  /** End date for filtering appointments (ISO format, required) */
  endDate: string;
  /** Optional filter by patient ID */
  patientId?: string | null;
  /** Filter by multiple patient IDs */
  patientIds?: string[] | null;
  /** Filter by specific provider IDs. Can specify one or more. */
  providerIds?: string[] | null;
  /** If true, return appointments for all providers in the organization. Overrides provider_ids. */
  allProviders?: boolean;
  /** Optional sort order - 'oldest_first' (default) or 'newest_first' */
  sort?: SortOrder | null;
};
export type PostV2ProviderAppointmentsApiResponse =
  /** status 201 Created */ AppointmentResponse2;
export type PostV2ProviderAppointmentsApiArg = {
  appointmentCreate: AppointmentCreate;
};
export type GetV2ProviderAppointmentsNextApiResponse =
  /** status 200 OK */ NextAppointmentResponse;
export type GetV2ProviderAppointmentsNextApiArg = {
  /** Optional filter by patient ID */
  patientId?: string | null;
  /** Optional number of appointments to return (default: 1) */
  num?: number | null;
  /** Grace period in minutes for appointments that have recently started. An appointment that started up to this many minutes ago can still be shown as 'next' (e.g., if provider is running late). Default: 10 minutes */
  includeRecentMinutes?: number | null;
  /** Return rich context with current/next/following appointments instead of simple list */
  contextMode?: boolean | null;
  /** Include currently ongoing appointments based on duration */
  includeCurrent?: boolean | null;
  /** (Context mode only) How far back to search for appointments that might still be ongoing. Ensures long appointments aren't missed. Default: 180 minutes (3 hours) */
  maxLookbackMinutes?: number | null;
};
export type PostV2ProviderAppointmentsSeriesApiResponse =
  /** status 201 Created */ SeriesResponse;
export type PostV2ProviderAppointmentsSeriesApiArg = {
  appointmentSeriesCreate: AppointmentSeriesCreate;
};
export type DeleteV2ProviderAppointmentsSeriesBySeriesIdApiResponse = unknown;
export type DeleteV2ProviderAppointmentsSeriesBySeriesIdApiArg = {
  seriesId: string;
};
export type GetV2ProviderAppointmentsSeriesBySeriesIdApiResponse =
  /** status 200 OK */ SeriesResponse;
export type GetV2ProviderAppointmentsSeriesBySeriesIdApiArg = {
  seriesId: string;
};
export type PatchV2ProviderAppointmentsSeriesBySeriesIdApiResponse =
  /** status 200 OK */ SeriesResponse;
export type PatchV2ProviderAppointmentsSeriesBySeriesIdApiArg = {
  seriesId: string;
  appointmentSeriesUpdate: AppointmentSeriesUpdate;
};
export type DeleteV2ProviderAppointmentsSeriesBySeriesIdFromAppointmentAndAppointmentIdApiResponse =
  unknown;
export type DeleteV2ProviderAppointmentsSeriesBySeriesIdFromAppointmentAndAppointmentIdApiArg =
  {
    seriesId: string;
    appointmentId: string;
  };
export type DeleteV2ProviderAppointmentsByAppointmentIdApiResponse =
  /** status 200 OK */ AppointmentResponse2;
export type DeleteV2ProviderAppointmentsByAppointmentIdApiArg = {
  appointmentId: string;
};
export type GetV2ProviderAppointmentsByAppointmentIdApiResponse =
  /** status 200 OK */ AppointmentResponse2;
export type GetV2ProviderAppointmentsByAppointmentIdApiArg = {
  appointmentId: string;
};
export type PatchV2ProviderAppointmentsByAppointmentIdApiResponse =
  /** status 200 OK */ AppointmentResponse2;
export type PatchV2ProviderAppointmentsByAppointmentIdApiArg = {
  appointmentId: string;
  appointmentUpdate: AppointmentUpdate;
};
export type PostV2ProviderAppointmentsByAppointmentIdNoShowApiResponse =
  /** status 200 OK */ AppointmentResponse2;
export type PostV2ProviderAppointmentsByAppointmentIdNoShowApiArg = {
  appointmentId: string;
};
export type PatchV2ProviderAppointmentsByAppointmentIdRejectApiResponse =
  /** status 200 OK */ AppointmentResponse2;
export type PatchV2ProviderAppointmentsByAppointmentIdRejectApiArg = {
  appointmentId: string;
  appointmentReject: AppointmentReject;
};
export type PostV2ProviderEncountersFromAppointmentByAppointmentIdApiResponse =
  /** status 201 Created */ EncounterResponse;
export type PostV2ProviderEncountersFromAppointmentByAppointmentIdApiArg = {
  appointmentId: string;
  /** If true, compute and apply attestation defaults (modality, place_of_service, icd10_codes, cpt_codes, attestations) based on context. Defaults to true for appointment-based encounters. */
  applyDefaults?: boolean | null;
};
export type GetV2ProviderEncountersByEncounterIdApiResponse =
  /** status 200 OK */ EncounterResponse;
export type GetV2ProviderEncountersByEncounterIdApiArg = {
  encounterId: string;
};
export type PatchV2ProviderEncountersByEncounterIdApiResponse =
  /** status 200 OK */ EncounterResponse;
export type PatchV2ProviderEncountersByEncounterIdApiArg = {
  encounterId: string;
  /** If true, compute and return suggested defaults based on current encounter state. Use when patient_id or encounter_type changes. */
  includeDefaults?: boolean | null;
  encounterUpdate: EncounterUpdate;
};
export type PostV2ProviderPatientsClinicalInfoApiResponse =
  /** status 200 OK */ PatientClinicalInfoBatchResponse;
export type PostV2ProviderPatientsClinicalInfoApiArg = {
  patientClinicalInfoRequest: PatientClinicalInfoRequest;
};
export type GetV2ProviderPatientsByPatientIdClinicalInfoApiResponse =
  /** status 200 OK */ PatientClinicalInfoResponse;
export type GetV2ProviderPatientsByPatientIdClinicalInfoApiArg = {
  patientId: string;
};
export type MaterializationResultResponse = {
  dry_run: boolean;
  errors: string[];
  parameters?: {
    [key: string]: any;
  } | null;
  processing_time_seconds: number;
  task_id?: string | null;
  task_name?: string | null;
  total_appointments_created: number;
  total_series_processed: number;
};
export type MaterializationTaskResponse = {
  message: string;
  parameters: {
    [key: string]: any;
  };
  status: string;
  task_id: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type MaterializationRequest = {
  /** If true, runs asynchronously via Celery */
  async_mode?: boolean;
  /** Number of series to process per batch */
  batch_size?: number;
  /** Number of days ahead to materialize appointments */
  days_ahead?: number;
  /** If true, simulates the materialization without creating appointments */
  dry_run?: boolean;
  /** List of provider IDs to process. If None, processes all providers. */
  provider_ids?: string[] | null;
};
export type MaterializationResultResponse2 = {
  dry_run: boolean;
  errors: string[];
  parameters?: {
    [key: string]: any;
  } | null;
  processing_time_seconds: number;
  task_id?: string | null;
  task_name?: string | null;
  total_appointments_created: number;
  total_series_processed: number;
};
export type TaskStatusResponse = {
  error?: string | null;
  message?: string | null;
  progress?: {
    [key: string]: any;
  } | null;
  ready: boolean;
  result?: MaterializationResultResponse2 | null;
  status: string;
  task_id: string;
  traceback?: string | null;
};
export type AdminAppointmentDetail = {
  appointment_id: string;
  created_at?: string | null;
  duration?: number | null;
  encounter_type?: string | null;
  encounter_type_id?: string | null;
  organization_id?: string | null;
  patient_id?: string | null;
  provider_id?: string | null;
  start_time?: string | null;
  status?: string | null;
  telehealth?: boolean | null;
  template_id?: string | null;
  title?: string | null;
  updated_at?: string | null;
};
export type AdminEncounterSummary = {
  appointment_id?: string | null;
  created_at?: string | null;
  encounter_id: string;
  encounter_type?: string | null;
  input_documents?: number | null;
  patient_id?: string | null;
  status?: string | null;
  updated_at?: string | null;
};
export type AdminNoteSummary = {
  created_at?: string | null;
  encounter_type?: string | null;
  has_feedback?: boolean | null;
  note_id: string;
  patient_id?: string | null;
  patient_name?: string | null;
  status?: string | null;
  template?: string | null;
};
export type AdminProviderSummary = {
  email?: string | null;
  last_login_time?: string | null;
  name?: string | null;
  organization_id?: string | null;
  organization_name?: string | null;
  provider_id: string;
  role?: string | null;
};
export type AdminTranscriptionSummary = {
  chunk_count?: number | null;
  created_at?: string | null;
  is_closed?: boolean | null;
  job_status?: string | null;
  notes_created?: number | null;
  start_time?: string | null;
  transcription_session_id: string;
};
export type AdminAppointmentDetailResponse = {
  appointment: AdminAppointmentDetail;
  encounter?: AdminEncounterSummary | null;
  notes: AdminNoteSummary[];
  provider: AdminProviderSummary;
  transcriptions: AdminTranscriptionSummary[];
};
export type AdminAppointmentResponse = {
  appointment_id: string;
  created_at?: string | null;
  duration?: number | null;
  encounter_type?: string | null;
  encounter_type_id?: string | null;
  organization_id?: string | null;
  patient_id?: string | null;
  provider_id?: string | null;
  series_id?: string | null;
  start_time: string;
  status: string;
  telehealth?: boolean | null;
  template_id?: string | null;
  title: string;
  updated_at?: string | null;
};
export type ListResponseAdminAppointmentResponse = {
  items: AdminAppointmentResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type InsuranceSummary = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Group/employer number */
  group_number?: string | null;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type ScheduledActionType =
  | "appointment_form"
  | "appointment_reminder"
  | "eligibility_check"
  | "insurance_discovery";
export type ScheduledActionStatus =
  | "pending"
  | "processing"
  | "completed"
  | "failed"
  | "cancelled";
export type ScheduledActionResponse = {
  /** Type of action */
  action_type: ScheduledActionType;
  /** Error message if action failed */
  error_message?: string | null;
  /** When the action was executed */
  executed_at?: string | null;
  /** Scheduled action ID */
  id: string;
  /** ID of the rule that created this action */
  rule_id?: string | null;
  /** When the action is/was scheduled to execute */
  scheduled_at: string;
  /** Action status */
  status: ScheduledActionStatus;
};
export type SeriesInfo = {
  /** Series end date (if any) */
  end_date?: string | null;
  /** RFC 5545 recurrence rule (RRULE) */
  rrule: string;
  /** Series ID */
  series_id: string;
};
export type AppointmentResponse = {
  /** Appointment ID */
  appointment_id: string;
  /** Color for appointment display (inherited from encounter type) */
  color?: string | null;
  /** Patient confirmation status (scheduled, cancelled, reschedule_requested, confirmed) */
  confirmation_status?: string | null;
  /** Creation timestamp */
  created_at: string;
  /** Daily.co room metadata for telehealth appointments (room_name, room_url, etc.) */
  daily_room_metadata?: {
    [key: string]: any;
  } | null;
  /** Calculated display title combining patient name and encounter type */
  display_title?: string | null;
  /** Appointment duration in minutes */
  duration: number;
  /** Associated encounter (if any) */
  encounter?: any | null;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Form rules for this appointment */
  form_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Flexible metadata for additional appointment data (e.g., suggested_action_id) */
  metadata?: {
    [key: string]: any;
  };
  /** Whether patient did not show up for appointment */
  no_showed?: boolean;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Whether rules are locked from being overridden by defaults */
  override_defaults?: boolean;
  /** Associated patient information */
  patient?: PatientInfo | null;
  /** Provider ID. None for unassigned appointments. */
  provider_id?: string | null;
  /** Reminder rules for this appointment */
  reminder_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Whether rules are locked from being updated */
  rules_locked?: boolean;
  /** Scheduled actions associated with this appointment */
  scheduled_actions?: ScheduledActionResponse[] | null;
  /** Series information for recurring appointments */
  series?: SeriesInfo | null;
  /** Series ID if part of a recurring series */
  series_id?: string | null;
  /** Appointment start time */
  start_time: string;
  /** Appointment status */
  status: string;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** Template ID associated with encounter type */
  template_id?: string | null;
  /** Appointment title */
  title?: string | null;
  /** Last update timestamp */
  updated_at: string;
};
export type AppointmentListResponse = {
  /** List of appointments */
  items: AppointmentResponse[];
};
export type SortOrder = "oldest_first" | "newest_first";
export type InsuranceSummary2 = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Group/employer number */
  group_number?: string | null;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo2 = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary2[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type ScheduledActionType2 =
  | "appointment_form"
  | "appointment_reminder"
  | "eligibility_check"
  | "insurance_discovery";
export type ScheduledActionStatus2 =
  | "pending"
  | "processing"
  | "completed"
  | "failed"
  | "cancelled";
export type ScheduledActionResponse2 = {
  /** Type of action */
  action_type: ScheduledActionType2;
  /** Error message if action failed */
  error_message?: string | null;
  /** When the action was executed */
  executed_at?: string | null;
  /** Scheduled action ID */
  id: string;
  /** ID of the rule that created this action */
  rule_id?: string | null;
  /** When the action is/was scheduled to execute */
  scheduled_at: string;
  /** Action status */
  status: ScheduledActionStatus2;
};
export type SeriesInfo2 = {
  /** Series end date (if any) */
  end_date?: string | null;
  /** RFC 5545 recurrence rule (RRULE) */
  rrule: string;
  /** Series ID */
  series_id: string;
};
export type AppointmentResponse2 = {
  /** Appointment ID */
  appointment_id: string;
  /** Color for appointment display (inherited from encounter type) */
  color?: string | null;
  /** Patient confirmation status (scheduled, cancelled, reschedule_requested, confirmed) */
  confirmation_status?: string | null;
  /** Creation timestamp */
  created_at: string;
  /** Daily.co room metadata for telehealth appointments (room_name, room_url, etc.) */
  daily_room_metadata?: {
    [key: string]: any;
  } | null;
  /** Calculated display title combining patient name and encounter type */
  display_title?: string | null;
  /** Appointment duration in minutes */
  duration: number;
  /** Associated encounter (if any) */
  encounter?: any | null;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Form rules for this appointment */
  form_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Flexible metadata for additional appointment data (e.g., suggested_action_id) */
  metadata?: {
    [key: string]: any;
  };
  /** Whether patient did not show up for appointment */
  no_showed?: boolean;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Whether rules are locked from being overridden by defaults */
  override_defaults?: boolean;
  /** Associated patient information */
  patient?: PatientInfo2 | null;
  /** Provider ID. None for unassigned appointments. */
  provider_id?: string | null;
  /** Reminder rules for this appointment */
  reminder_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Whether rules are locked from being updated */
  rules_locked?: boolean;
  /** Scheduled actions associated with this appointment */
  scheduled_actions?: ScheduledActionResponse2[] | null;
  /** Series information for recurring appointments */
  series?: SeriesInfo2 | null;
  /** Series ID if part of a recurring series */
  series_id?: string | null;
  /** Appointment start time */
  start_time: string;
  /** Appointment status */
  status: string;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** Template ID associated with encounter type */
  template_id?: string | null;
  /** Appointment title */
  title?: string | null;
  /** Last update timestamp */
  updated_at: string;
};
export type FormRuleSchema = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type AppointmentCreate = {
  /** Appointment duration in minutes */
  duration: number;
  /** Encounter type name (will be created if doesn't exist) */
  encounter_type?: string | null;
  /** Encounter type ID (alternative to encounter_type/template_id) */
  encounter_type_id?: string | null;
  /** Form rules for this appointment (overrides encounter type defaults) */
  form_rules?: FormRuleSchema[] | null;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Lock the rules to prevent them from being overridden by defaults */
  override_defaults?: boolean | null;
  /** Patient ID to associate with this appointment */
  patient_id: string;
  /** Provider ID to create appointment for (admin only, defaults to self) */
  provider_id?: string | null;
  /** Reminder rules for this appointment (overrides encounter type defaults) */
  reminder_rules?: ReminderRuleSchema[] | null;
  /** Appointment start time (ISO format) */
  start_time: string;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** Template ID (associated with encounter type) */
  template_id?: string | null;
};
export type InsuranceSummary3 = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Group/employer number */
  group_number?: string | null;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo3 = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary3[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type ScheduledActionType3 =
  | "appointment_form"
  | "appointment_reminder"
  | "eligibility_check"
  | "insurance_discovery";
export type ScheduledActionStatus3 =
  | "pending"
  | "processing"
  | "completed"
  | "failed"
  | "cancelled";
export type ScheduledActionResponse3 = {
  /** Type of action */
  action_type: ScheduledActionType3;
  /** Error message if action failed */
  error_message?: string | null;
  /** When the action was executed */
  executed_at?: string | null;
  /** Scheduled action ID */
  id: string;
  /** ID of the rule that created this action */
  rule_id?: string | null;
  /** When the action is/was scheduled to execute */
  scheduled_at: string;
  /** Action status */
  status: ScheduledActionStatus3;
};
export type SeriesInfo3 = {
  /** Series end date (if any) */
  end_date?: string | null;
  /** RFC 5545 recurrence rule (RRULE) */
  rrule: string;
  /** Series ID */
  series_id: string;
};
export type AppointmentResponse3 = {
  /** Appointment ID */
  appointment_id: string;
  /** Color for appointment display (inherited from encounter type) */
  color?: string | null;
  /** Patient confirmation status (scheduled, cancelled, reschedule_requested, confirmed) */
  confirmation_status?: string | null;
  /** Creation timestamp */
  created_at: string;
  /** Daily.co room metadata for telehealth appointments (room_name, room_url, etc.) */
  daily_room_metadata?: {
    [key: string]: any;
  } | null;
  /** Calculated display title combining patient name and encounter type */
  display_title?: string | null;
  /** Appointment duration in minutes */
  duration: number;
  /** Associated encounter (if any) */
  encounter?: any | null;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Form rules for this appointment */
  form_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Flexible metadata for additional appointment data (e.g., suggested_action_id) */
  metadata?: {
    [key: string]: any;
  };
  /** Whether patient did not show up for appointment */
  no_showed?: boolean;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Whether rules are locked from being overridden by defaults */
  override_defaults?: boolean;
  /** Associated patient information */
  patient?: PatientInfo3 | null;
  /** Provider ID. None for unassigned appointments. */
  provider_id?: string | null;
  /** Reminder rules for this appointment */
  reminder_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Whether rules are locked from being updated */
  rules_locked?: boolean;
  /** Scheduled actions associated with this appointment */
  scheduled_actions?: ScheduledActionResponse3[] | null;
  /** Series information for recurring appointments */
  series?: SeriesInfo3 | null;
  /** Series ID if part of a recurring series */
  series_id?: string | null;
  /** Appointment start time */
  start_time: string;
  /** Appointment status */
  status: string;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** Template ID associated with encounter type */
  template_id?: string | null;
  /** Appointment title */
  title?: string | null;
  /** Last update timestamp */
  updated_at: string;
};
export type AppointmentTimingInfo = {
  /** Whether appointment is past scheduled end time */
  is_overtime?: boolean | null;
  /** Whether appointment is within late arrival grace period */
  is_within_grace_period?: boolean | null;
  /** Minutes since appointment started */
  minutes_elapsed?: number | null;
  /** Minutes until scheduled end */
  minutes_remaining?: number | null;
  /** Minutes until appointment starts (negative if already started) */
  minutes_until_start?: number | null;
  /** Scheduled end time based on duration */
  scheduled_end: string;
  /** Scheduled start time */
  scheduled_start: string;
};
export type CurrentAppointmentContext = {
  /** The appointment data */
  appointment: AppointmentResponse3;
  /** Timing information */
  timing: AppointmentTimingInfo;
};
export type NextAppointmentContext = {
  /** The appointment data */
  appointment: AppointmentResponse3;
  /** Timing information */
  timing: AppointmentTimingInfo;
};
export type NextAppointmentResponse = {
  /** List of all currently ongoing appointments with timing info. Returns all overlapping appointments. Only populated in context mode (context_mode=true). */
  current?: CurrentAppointmentContext[] | null;
  /** List of following appointments for preview. Only populated in context mode (context_mode=true). */
  following?: AppointmentResponse3[] | null;
  /** List of upcoming appointments. Only populated in legacy mode (context_mode=false). */
  items?: AppointmentResponse3[] | null;
  /** List of all next upcoming appointments with timing info. Returns all appointments starting at the earliest upcoming time. Only populated in context mode (context_mode=true). */
  next?: NextAppointmentContext[] | null;
};
export type FormRuleSchema2 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema2 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type SeriesResponse = {
  /** Creation timestamp */
  created_at: string;
  /** Default form rules for this series */
  default_form_rules?: FormRuleSchema2[] | null;
  /** Default reminder rules for this series */
  default_reminder_rules?: ReminderRuleSchema2[] | null;
  /** Appointment duration in minutes */
  duration: number;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Series end date (if any) */
  end_date?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Whether rules are locked from being overridden by defaults */
  override_defaults?: boolean;
  /** Provider ID */
  provider_id: string;
  /** Recurrence rule (RFC 5545) */
  rrule: string;
  /** Whether rules are locked from being updated */
  rules_locked?: boolean;
  /** Series ID */
  series_id: string;
  /** Whether appointments are telehealth/virtual */
  telehealth?: boolean | null;
  /** Template ID associated with encounter type */
  template_id?: string | null;
  /** Series title */
  title?: string | null;
  /** Last update timestamp */
  updated_at: string;
};
export type FormRuleSchema3 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema3 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type AppointmentSeriesCreate = {
  /** Default form rules for appointments in this series */
  default_form_rules?: FormRuleSchema3[] | null;
  /** Default reminder rules for appointments in this series */
  default_reminder_rules?: ReminderRuleSchema3[] | null;
  /** Appointment duration in minutes */
  duration: number;
  /** Encounter type name (will be created if doesn't exist) */
  encounter_type?: string | null;
  /** Encounter type ID (alternative to encounter_type/template_id) */
  encounter_type_id?: string | null;
  /** Optional end date for the series */
  end_date?: string | null;
  /** Lock the rules to prevent them from being overridden by defaults */
  override_defaults?: boolean | null;
  /** Patient ID to associate with this appointment series */
  patient_id: string;
  /** Provider ID to create series for (admin only, defaults to self) */
  provider_id?: string | null;
  /** RFC 5545 recurrence rule (RRULE) */
  rrule: string;
  /** Initial appointment start time */
  start_time: string;
  /** Whether appointments in this series are telehealth/virtual */
  telehealth?: boolean | null;
  /** Template ID (associated with encounter type) */
  template_id?: string | null;
};
export type FormRuleSchema4 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema4 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type AppointmentSeriesUpdate = {
  /** Default form rules for appointments in this series */
  default_form_rules?: FormRuleSchema4[] | null;
  /** Default reminder rules for appointments in this series */
  default_reminder_rules?: ReminderRuleSchema4[] | null;
  /** New duration in minutes */
  duration?: number | null;
  /** New encounter type */
  encounter_type?: string | null;
  /** Encounter type ID (alternative to encounter_type/template_id) */
  encounter_type_id?: string | null;
  /** New end date for the series */
  end_date?: string | null;
  /** Lock the rules to prevent them from being overridden by defaults */
  override_defaults?: boolean | null;
  /** New recurrence rule */
  rrule?: string | null;
  /** Whether appointments are telehealth/virtual */
  telehealth?: boolean | null;
  /** New template ID */
  template_id?: string | null;
};
export type FormRuleSchema5 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema5 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type AppointmentStatus =
  | "scheduled"
  | "cancelled"
  | "rescheduled"
  | "suggested"
  | "rejected";
export type AppointmentUpdate = {
  /** Create a new series from this appointment */
  create_series?: boolean | null;
  /** Detach this appointment from its series and set the series to end before this occurrence */
  detach_from_series?: boolean | null;
  /** New appointment duration in minutes */
  duration?: number | null;
  /** New encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID (alternative to encounter_type/template_id) */
  encounter_type_id?: string | null;
  /** Form rules for this appointment */
  form_rules?: FormRuleSchema5[] | null;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Lock the rules to prevent them from being overridden by defaults */
  override_defaults?: boolean | null;
  /** Patient ID for the appointment */
  patient_id?: string | null;
  /** Reminder rules for this appointment */
  reminder_rules?: ReminderRuleSchema5[] | null;
  /** RFC 5545 recurrence rule for creating a series */
  rrule?: string | null;
  /** End date for the new series */
  series_end_date?: string | null;
  /** New appointment start time */
  start_time?: string | null;
  /** New appointment status */
  status?: AppointmentStatus | null;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** New template ID */
  template_id?: string | null;
};
export type AppointmentReject = {};
export type AppointmentResponseBase = {
  /** Appointment ID */
  appointment_id: string;
  /** Color for appointment display (inherited from encounter type) */
  color?: string | null;
  /** Patient confirmation status (scheduled, cancelled, reschedule_requested, confirmed) */
  confirmation_status?: string | null;
  /** Creation timestamp */
  created_at: string;
  /** Daily.co room metadata for telehealth appointments (room_name, room_url, etc.) */
  daily_room_metadata?: {
    [key: string]: any;
  } | null;
  /** Calculated display title combining patient name and encounter type */
  display_title?: string | null;
  /** Appointment duration in minutes */
  duration: number;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Form rules for this appointment */
  form_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Flexible metadata for additional appointment data (e.g., suggested_action_id) */
  metadata?: {
    [key: string]: any;
  };
  /** Whether patient did not show up for appointment */
  no_showed?: boolean;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Whether rules are locked from being overridden by defaults */
  override_defaults?: boolean;
  /** Provider ID. None for unassigned appointments. */
  provider_id?: string | null;
  /** Reminder rules for this appointment */
  reminder_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Whether rules are locked from being updated */
  rules_locked?: boolean;
  /** Series ID if part of a recurring series */
  series_id?: string | null;
  /** Appointment start time */
  start_time: string;
  /** Appointment status */
  status: string;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** Template ID associated with encounter type */
  template_id?: string | null;
  /** Appointment title */
  title?: string | null;
  /** Last update timestamp */
  updated_at: string;
};
export type ClaimReference = {
  /** Claim type (original, corrected, void) */
  claim_type?: string | null;
  /** When the claim was created */
  created_at?: string | null;
  /** Claim UUID */
  id: string;
  /** Insurance payer name for display */
  insurance_payer_name?: string | null;
  /** Claim status (draft, processing, ready, submitted, acknowledged, accepted, rejected) */
  status: string;
  /** When the claim was submitted */
  submitted_at?: string | null;
  /** Total charges in cents */
  total_charge_cents?: number;
};
export type ComputedDefaults = {
  /** Default values for attestation checkboxes */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Default CPT codes from encounter type */
  cpt_codes?: string[];
  /** Default ICD-10 codes from last patient encounter */
  icd10_codes?: string[];
  /** Default modality */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Default place of service code */
  place_of_service?: string | null;
};
export type DocumentCountsMap = {
  /** Map of document type to count */
  counts: {
    [key: string]: number;
  };
  /** Total count of all documents */
  total: number;
};
export type DocumentSummary = {
  /** Count of input documents by type */
  input_counts: DocumentCountsMap;
  /** Count of output documents by type */
  output_counts: DocumentCountsMap;
};
export type EncounterDocumentReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Encounter document ID */
  encounter_document_id: string;
  /** Output status */
  status?: "pending" | "completed";
  /** Document title for display */
  title?: string | null;
  /** Document type */
  type: "text" | "recording" | "document" | "note";
};
export type JotDocReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** JotDoc ID (None for pending outputs) */
  jotdoc_id?: string | null;
  /** Output status */
  status?: "pending" | "completed";
  /** Task ID for tracking (optional, for debugging) */
  task_id?: string | null;
  /** Thread ID for building SSE stream URL */
  thread_id?: string | null;
  /** Document title */
  title?: string | null;
  /** Document type */
  type?: string;
};
export type InsuranceSummary4 = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Group/employer number */
  group_number?: string | null;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo4 = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary4[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type EncounterBillingSummary = {
  /** Most recent PAYMENT entry date */
  last_payment_date?: string | null;
  /** Net encounter-scoped patient balance */
  patient_balance_cents: number;
  /** Highest-priority status across charge_lines */
  patient_due_status: string;
  /** Sum of charge_line amounts for this encounter */
  total_charge_cents: number;
  /** Sum of patient PAYMENT entries for this encounter */
  total_paid_cents: number;
  /** Account-level unallocated credit */
  unapplied_credit_cents: number;
};
export type WorkingBillingClaimLineItemResponse = {
  /** Charge amount in cents for the line item */
  charge_cents?: number | null;
  /** Billing code identifier */
  code_id?: string | null;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  /** Provenance for each modifier, keyed by modifier code */
  modifier_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  modifiers?: string[];
  /** Whether this line item came from provider edits or AI */
  source?: ("provider_selected" | "ai_recommended") | null;
  /** Units billed */
  units?: number | null;
};
export type WorkingBillingClaimResponse = {
  created_at?: string | null;
  /** Provenance for each diagnosis code, keyed by normalized ICD-10 code */
  diagnosis_code_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  diagnosis_codes?: string[];
  encounter_id?: string | null;
  line_items?: WorkingBillingClaimLineItemResponse[];
  organization_id?: string | null;
  place_of_service?: string | null;
  updated_at?: string | null;
};
export type EncounterResponse = {
  /** Associated appointment if any */
  appointment?: AppointmentResponseBase | null;
  /** Flexible attestation data */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Whether the current user can delete transcripts (owner or org admin) */
  can_delete_transcripts?: boolean | null;
  /** Associated claims for this encounter (all versions: original, corrected, void) */
  claims?: ClaimReference[] | null;
  /** Suggested default values based on patient, encounter_type, and modality. Frontend can apply these when appropriate. */
  computed_defaults?: ComputedDefaults | null;
  /** CPT codes selected for this encounter */
  cpt_codes?: string[];
  /** Creation timestamp */
  created_at: string;
  /** Canonical billing date (CMS-1500 Box 24A) */
  date_of_service?: string | null;
  /** Summary of document counts */
  document_summary?: DocumentSummary | null;
  /** Encounter analysis payload if available */
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  /** Encounter ID */
  encounter_id: string;
  /** Encounter type */
  encounter_type?: string | null;
  /** Encounter type ID (from the linked appointment, if any) */
  encounter_type_id?: string | null;
  /** Encounter end time */
  end_time?: string | null;
  /** ICD-10 diagnosis codes for billing (max 4, first is primary) */
  icd10_codes?: string[];
  /** Input documents or recordings */
  inputs?: EncounterDocumentReference[];
  /** How the encounter was conducted */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Last modification timestamp */
  modified_at?: string | null;
  /** Legacy note ID */
  note_id?: string | null;
  /** Note title */
  note_title?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Output documents or notes */
  outputs?: (EncounterDocumentReference | JotDocReference)[];
  /** Associated patient information */
  patient?: PatientInfo4 | null;
  /** Patient financial summary for this encounter. None if no charge_lines exist yet (pre-claim-submission). */
  patient_billing?: EncounterBillingSummary | null;
  /** Patient ID */
  patient_id?: string | null;
  /** CMS place of service code (e.g., '11', '10', '02') */
  place_of_service?: string | null;
  /** Provider ID */
  provider_id: string;
  /** Timestamp confirming service was rendered */
  service_rendered_at?: string | null;
  /** Encounter start time */
  start_time?: string | null;
  /** Encounter status */
  status: string;
  /** Template ID */
  template_id?: string | null;
  /** Whether transcripts have been deleted for this encounter */
  transcripts_deleted?: boolean;
  /** Last update timestamp */
  updated_at: string;
  /** Canonical encounter-level working billing claim (read-only) */
  working_billing_claim?: WorkingBillingClaimResponse | null;
};
export type FormRuleSchema6 = {
  /** ID of the form definition */
  form_definition_id: string;
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** Title of the rule */
  title?: string | null;
};
export type ReminderRuleSchema6 = {
  /** Unique identifier for the rule */
  id?: string | null;
  /** ISO 8601 duration format (e.g., '-P1D' for 1 day before) */
  offset: string;
  /** ID of the reminder template */
  reminder_template_id: string;
  /** Title of the rule */
  title?: string | null;
};
export type AppointmentStatus2 =
  | "scheduled"
  | "cancelled"
  | "rescheduled"
  | "suggested"
  | "rejected";
export type AppointmentUpdate2 = {
  /** Create a new series from this appointment */
  create_series?: boolean | null;
  /** Detach this appointment from its series and set the series to end before this occurrence */
  detach_from_series?: boolean | null;
  /** New appointment duration in minutes */
  duration?: number | null;
  /** New encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID (alternative to encounter_type/template_id) */
  encounter_type_id?: string | null;
  /** Form rules for this appointment */
  form_rules?: FormRuleSchema6[] | null;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Lock the rules to prevent them from being overridden by defaults */
  override_defaults?: boolean | null;
  /** Patient ID for the appointment */
  patient_id?: string | null;
  /** Reminder rules for this appointment */
  reminder_rules?: ReminderRuleSchema6[] | null;
  /** RFC 5545 recurrence rule for creating a series */
  rrule?: string | null;
  /** End date for the new series */
  series_end_date?: string | null;
  /** New appointment start time */
  start_time?: string | null;
  /** New appointment status */
  status?: AppointmentStatus2 | null;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** New template ID */
  template_id?: string | null;
};
export type AppointmentCreateFromEncounter = {
  /** Appointment duration in minutes (required) */
  duration: number;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Patient ID for the appointment (optional) */
  patient_id?: string | null;
  /** Appointment start time (required) */
  start_time: string;
  /** Template ID */
  template_id?: string | null;
  /** Appointment title */
  title?: string | null;
};
export type EncounterUpdate = {
  /** Updates to make to the associated appointment, or data to create a new one if none exists */
  appointment?: AppointmentUpdate2 | AppointmentCreateFromEncounter | null;
  /** Flexible attestation data (telehealth_consent, pdmp_reviewed, etc.) */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Whether to create a new appointment if one doesn't exist. If true, required fields must be provided. */
  create_appointment?: boolean | null;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID. Preferred over encounter_type — avoids name-based matching. */
  encounter_type_id?: string | null;
  /** Encounter end time */
  end_time?: string | null;
  /** How the encounter was conducted */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Note title */
  note_title?: string | null;
  /** Patient ID */
  patient_id?: string | null;
  /** Encounter start time */
  start_time?: string | null;
  /** Encounter status */
  status?: ("pending" | "processing" | "completed") | null;
  /** Template ID */
  template_id?: string | null;
};
export type DiagnosisStatus = "accepted" | "suggested" | "rejected";
export type DiagnosisInfo = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  date_accepted?: string | null;
  date_added?: string | null;
  diagnosis_id: string;
  /** ISO 8601 date when diagnosis was resolved */
  end_date?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Whether the diagnosis is currently active */
  is_active?: boolean;
  name: string;
  status: DiagnosisStatus;
};
export type LastSession = {
  /** Date of the last session */
  date_completed?: string | null;
  /** Summary of the last session */
  summary?: string | null;
};
export type MedicationStatus =
  | "accepted"
  | "suggested"
  | "rejected"
  | "discontinued";
export type MedicationInfo = {
  date_accepted?: string | null;
  date_prescribed?: string | null;
  dosage?: string | null;
  /** ISO 8601 date when medication was stopped */
  end_date?: string | null;
  /** Formulation (e.g., tablet, capsule, liquid) */
  form?: string | null;
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Diagnosis or reason for prescribing */
  indication?: string | null;
  /** Whether the medication is currently active */
  is_active?: boolean;
  medication_id: string;
  name: string;
  /** Route of administration (e.g., oral, topical) */
  route?: string | null;
  /** ISO 8601 date when medication was started */
  start_date?: string | null;
  status: MedicationStatus;
  /** Strength per unit (e.g., 50mg) */
  strength?: string | null;
  /** When to take (e.g., morning, bedtime, with food) */
  timing?: string | null;
};
export type PatientAddress = {
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (apartment, suite, etc.) */
  line2?: string | null;
  /** Optional landline/location phone in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code (5 or 9 digit format, e.g., 12345 or 12345-6789) */
  zip?: string | null;
};
export type ScoreEntry = {
  date?: string | null;
  interpretation?: string | null;
  score: number;
};
export type ScoreTrend = "up" | "down" | "stable";
export type QuestionnaireInfo = {
  /** Date of most recent completion */
  date_completed?: string | null;
  /** Name of the questionnaire (e.g., PHQ-9, GAD-7) */
  name: string;
  /** Previous score for comparison */
  previous_score?: number | null;
  questionnaire_id: string;
  /** Most recent score */
  score?: number | null;
  /** Full score history, chronological order */
  scores?: ScoreEntry[];
  /** Score trend direction */
  trend?: ScoreTrend | null;
};
export type PatientClinicalInfo = {
  diagnoses?: DiagnosisInfo[];
  dob?: string | null;
  email?: string | null;
  first_name?: string | null;
  gender?: string | null;
  has_pending_diagnosis_suggestions?: boolean;
  has_pending_medication_suggestions?: boolean;
  last_name?: string | null;
  last_session?: LastSession | null;
  medications?: MedicationInfo[];
  middle_name?: string | null;
  mobile_phone?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  primary_address?: PatientAddress | null;
  pronouns?: string | null;
  questionnaires?: QuestionnaireInfo[];
};
export type PatientClinicalInfoBatchResponse = {
  /** List of patient details */
  patients: PatientClinicalInfo[];
  /** Number of patients found and accessible */
  total_found: number;
  /** Total number of patient IDs requested */
  total_requested: number;
};
export type PatientClinicalInfoRequest = {
  /** List of patient IDs to fetch details for */
  patient_ids: string[];
};
export type DiagnosisStatus2 = "accepted" | "suggested" | "rejected";
export type DiagnosisInfo2 = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  date_accepted?: string | null;
  date_added?: string | null;
  diagnosis_id: string;
  /** ISO 8601 date when diagnosis was resolved */
  end_date?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Whether the diagnosis is currently active */
  is_active?: boolean;
  name: string;
  status: DiagnosisStatus2;
};
export type LastSession2 = {
  /** Date of the last session */
  date_completed?: string | null;
  /** Summary of the last session */
  summary?: string | null;
};
export type MedicationStatus2 =
  | "accepted"
  | "suggested"
  | "rejected"
  | "discontinued";
export type MedicationInfo2 = {
  date_accepted?: string | null;
  date_prescribed?: string | null;
  dosage?: string | null;
  /** ISO 8601 date when medication was stopped */
  end_date?: string | null;
  /** Formulation (e.g., tablet, capsule, liquid) */
  form?: string | null;
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Whether there are pending suggestions */
  has_suggestions?: boolean;
  /** Diagnosis or reason for prescribing */
  indication?: string | null;
  /** Whether the medication is currently active */
  is_active?: boolean;
  medication_id: string;
  name: string;
  /** Route of administration (e.g., oral, topical) */
  route?: string | null;
  /** ISO 8601 date when medication was started */
  start_date?: string | null;
  status: MedicationStatus2;
  /** Strength per unit (e.g., 50mg) */
  strength?: string | null;
  /** When to take (e.g., morning, bedtime, with food) */
  timing?: string | null;
};
export type PatientAddress2 = {
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (apartment, suite, etc.) */
  line2?: string | null;
  /** Optional landline/location phone in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code (5 or 9 digit format, e.g., 12345 or 12345-6789) */
  zip?: string | null;
};
export type ScoreEntry2 = {
  date?: string | null;
  interpretation?: string | null;
  score: number;
};
export type ScoreTrend2 = "up" | "down" | "stable";
export type QuestionnaireInfo2 = {
  /** Date of most recent completion */
  date_completed?: string | null;
  /** Name of the questionnaire (e.g., PHQ-9, GAD-7) */
  name: string;
  /** Previous score for comparison */
  previous_score?: number | null;
  questionnaire_id: string;
  /** Most recent score */
  score?: number | null;
  /** Full score history, chronological order */
  scores?: ScoreEntry2[];
  /** Score trend direction */
  trend?: ScoreTrend2 | null;
};
export type PatientClinicalInfo2 = {
  diagnoses?: DiagnosisInfo2[];
  dob?: string | null;
  email?: string | null;
  first_name?: string | null;
  gender?: string | null;
  has_pending_diagnosis_suggestions?: boolean;
  has_pending_medication_suggestions?: boolean;
  last_name?: string | null;
  last_session?: LastSession2 | null;
  medications?: MedicationInfo2[];
  middle_name?: string | null;
  mobile_phone?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  primary_address?: PatientAddress2 | null;
  pronouns?: string | null;
  questionnaires?: QuestionnaireInfo2[];
};
export type PatientClinicalInfoResponse = {
  /** Patient clinical info */
  patient_clinical_info: PatientClinicalInfo2;
};
